
import { Clock, Target, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import WhyChooseUs from "@/components/shared/WhyChooseUs";
import { getAuthUrl } from "@/utils/redirectUtils";

const StartupHero = () => {
  return (
    <div className="flex flex-col md:flex-row gap-8 mb-16 items-center">
      <div className="md:w-1/2">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Launch Your Campaign, Not Just Your Product</h1>
        <h2 className="text-2xl text-amber-500 mb-6">Get your first campaign live in 5 minutes</h2>
        <p className="text-lg text-muted-foreground mb-6">
          Speed is everything for startups. Our AI-powered platform gets your Google Ads campaign live in 5 minutes, helps you test new markets quickly, and makes your limited budget work harder than ever.
        </p>
        
        <div className="mb-6">
          <WhyChooseUs 
            showTitle={false} 
            condensed={true}
            valueProps={[
              { icon: <Clock className="h-5 w-5 text-amber-500 mr-2" />, text: "Launch campaigns in 5 minutes" },
              { icon: <Target className="h-5 w-5 text-amber-500 mr-2" />, text: "Test new markets quickly" },
              { icon: <Zap className="h-5 w-5 text-amber-500 mr-2" />, text: "Make small budgets work harder" }
            ]}
          />
        </div>
        
        <div className="flex justify-center">
          <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white">
            <a href={getAuthUrl()}>Launch Campaign Now for Free</a>
          </Button>
        </div>
      </div>
      
      <div className="md:w-1/2 bg-white p-4 rounded-lg shadow-lg border border-amber-200">
        <svg 
          viewBox="0 0 800 600" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-auto"
        >
          <rect width="800" height="600" fill="#FEF3C7" />
          <circle cx="400" cy="300" r="200" fill="#FBBF24" opacity="0.2" />
          <path d="M100,400 Q200,200 400,300 Q600,400 700,200" stroke="#F59E0B" strokeWidth="10" fill="none" opacity="0.6" />
          <path d="M150,450 Q250,350 350,400 Q450,450 550,350 Q650,250 750,350" stroke="#F59E0B" strokeWidth="6" fill="none" opacity="0.4" />
          <path d="M200,200 Q300,150 400,200 Q500,250 600,150" stroke="#F59E0B" strokeWidth="8" fill="none" opacity="0.5" />
          <rect x="300" y="250" width="200" height="150" rx="10" fill="white" />
          <line x1="330" y1="290" x2="470" y2="290" stroke="#F59E0B" strokeWidth="15" strokeLinecap="round" />
          <line x1="330" y1="330" x2="420" y2="330" stroke="#D1D5DB" strokeWidth="10" strokeLinecap="round" />
          <line x1="330" y1="360" x2="450" y2="360" stroke="#D1D5DB" strokeWidth="10" strokeLinecap="round" />
          <circle cx="150" cy="150" r="50" fill="#F59E0B" opacity="0.4" />
          <circle cx="650" cy="450" r="70" fill="#F59E0B" opacity="0.3" />
        </svg>
      </div>
    </div>
  );
};

export default StartupHero;
